import { BasicBlock, BLOCK_CATEGORY_TYPE, BlockConfig, DEFAULT_CANVAS_DISPLACEMENT_X } from '@sections/creabots/types/kits'
import getBlocksInfoSchema from '../../../config/getBlocksInfoSchema'

const blocks: BasicBlock[] = [
  {
    id: 0,
    name: 'variables_set_dynamic',
  },
  {
    id: 1,
    name: 'variables_declare_global_dynamic',
  },
  {
    id: 2,
    name: 'variables_declare_local_dynamic',
  },
  {
    id: 3,
    name: 'variables_get_dynamic',
  },
]

export const variablesConfig: BlockConfig = {
  blockCategory: 3,
  canvasDisplacement: { x: DEFAULT_CANVAS_DISPLACEMENT_X, y: 0 },
  blocks: getBlocksInfoSchema(blocks, BLOCK_CATEGORY_TYPE.VARIABLES),
}